<template>
  <div id="duty">
    <el-row class="total-header">
        <el-col style="padding-left:20px;" :span="3">
          <el-select
            v-model="search.termId"
            filterable
            placeholder="请选择学期"
            @change="filter"
          >
            <el-option v-for="item in termData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
    </el-row>
    <el-row style="text-align:center;font-weight:bold;font-size:24px;">{{currentTerm}}应出勤{{currentNum}}次</el-row>
     <el-row class="total-chart-row" style="margin-top：30px;">
          <el-col :span="12" class="total-chart-col">
            <v-chart class="list-chart" :initOptions="initOptions" :options="sexOptions"/>
          </el-col>
           <el-col :span="12" class="total-chart-borderright total-chart-col">
            <v-chart class="list-chart" :initOptions="initOptions" :options="personOptions"/>
          </el-col>
        </el-row>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";

export default {
  name: "duty",
  props: ["tabindex",'authId'],
   components: {
    "v-chart": ECharts
  },
  data() {
    return {
     termData:[],
     search:{
        termId:null,
     },
     currentTerm:null,
     currentNum:null,
      initOptions: {
        renderer: "canvas"
      },
        // 在读情况
      personOptions: {
      
        color: ["#5b9bd5"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "出勤次数",
              "请假次数"
            ],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          { // 纵轴标尺固定
            type : 'value',
            scale : true,
            max : 200,
            min : 0,
            splitNumber : 5,
            boundaryGap : [ 0.2, 0.2 ]
          }
        ],
        series: [
          {
            type: "bar",
            barWidth: "20%",
            data: [0, 0]
          }]
      },
      sexOptions: {
        title: {
          text: "在职情况",
          top: '20',
          let: 'center',
          right: 'center'
        },
        color: ["#5b9bd5", "#ed7d31"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        grid: {
          bottom: "14%",
          containLabel: true
        },
        series: [
            {
            name: "出勤率",
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            // label: {
            //  normal: {
            //         show: false,
            //         formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
            //         backgroundColor: '#eee',
            //         borderColor: '#aaa',
            //         borderWidth: 1,
            //         borderRadius: 4,
            //         rich: {
            //             a: {
            //                 color: '#999',
            //                 lineHeight: 22,
            //                 align: 'center'
            //             },
            //             hr: {
            //                 borderColor: '#aaa',
            //                 width: '100%',
            //                 borderWidth: 0.5,
            //                 height: 0
            //             },
            //             b: {
            //                 fontSize: 16,
            //                 lineHeight: 33
            //             },
            //             per: {
            //                 color: '#eee',
            //                 backgroundColor: '#334455',
            //                 padding: [2, 4],
            //                 borderRadius: 2
            //             }
            //         }
            //     },
                
            // },
            data: [
                { value: null, name: '缺勤',label: {show: true , fontWeight: 'bold'}},
                {value: null, name: '实际出勤',label: {show: true , fontWeight: 'bold'}},
            ],  
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      
     
    };
  },
  async mounted() {
    let me = this;
     me.$watch("tabindex", async function(val, oldval) {
      if (val == '2') {
          await  me.getTerm();
          await  me.setCurrentTerm();
          await me.countBySingleStudent()   
        }
    })
    
     
  },
  methods: {
    filter(){
          this.countBySingleStudent();
    },
      //  查询学期信息
    async getTerm() {
      let param = {
        pageIndex: 1,
        pageSize: 10
      };
      let term = await this.$recruitService.queryTerm(param);
      if (term && term.success) {
          this.termData = term.content.records;
      }
    },
      //  考情详情
    async countBySingleStudent() {
      let param={
        termId:this.search.termId
      };
      let term = await this.$team.countBySingleStudent(param);
      if (term && term.success) {
         this.currentNum=term.content.allNeedNum;
         this.sexOptions.series[0].data[0].value =(term.content.allNeedNum- term.content.num)
          this.sexOptions.series[0].data[1].value =term.content.num;
           this.personOptions.yAxis[0].max=term.content.allNeedNum;
          this.personOptions.series[0].data=[
              Number(term.content.num),
              Number(term.content.other)+Number(term.content.absence)+Number(term.content.sick),      
          ]
      }
    },
     // 设置当前学期
    async setCurrentTerm () {
      let res = await this.$team.queryNowTerm({});
      if (res.success) {
        this.termData.forEach(item => {
          if (item.id === res.content.id) {
            this.search.termId = res.content.id;
            this.currentTerm=res.content.name;
          }
        });
        if (!this.search.termId && this.termData && this.termData[0]) {
          this.search.termId = this.termData[0].id;
        }
      }
    },
      saveCampus(){

      },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/attendance/child/onDuty.vue